import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import Router from './utils/Router'
import reportWebVitals from './reportWebVitals'
import { ThemeProvider } from '@emotion/react'
import { lightTheme } from './utils/Theme'

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={lightTheme}>
      <Router />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
